import ReportesLogo from "../../../assets/saludproxapps/reportes.svg";
import DoctorProxLogo from "../../../assets/saludproxapps/doctorprox.svg";
import SaludProxLogo from "../../../assets/saludproxapps/saludprox.svg";
import SaludProxAppsLogo from "../../../assets/saludproxapps/saludproxapps.svg";
import SistemaOperacionalLogo from "../../../assets/saludproxapps/so-v.svg";
import { environment } from "@environments/environment";
import { getSubdomainByLocation } from "@functions/getSubDomainSalud";
import { IPermission } from "@interfaces/fc-user/permissions";
import { useSelector } from "react-redux";
import { RootState } from "@redux/store";

interface ISaludProxAppsProps
{
    permissionsReports: IPermission[],
    setOpenAppsCard: (status:boolean) => void,
    organizationId: number | string
}

const SaludProxApps = (props: ISaludProxAppsProps) => {
    const { permissionsReports, setOpenAppsCard, organizationId } = props
    const {session} = useSelector((state: RootState) => ({session: state.session}));

    const getRole = (roleToFind: string) => {
        const roleFound = session.roles.find( role => role.code === roleToFind)
        return Boolean(roleFound) 
    }
    const validAccessRoles = ()=>{
        let access = false
        if (permissionsReports.length) 
        {
            let countWrite = 0; 
            permissionsReports.forEach((p) => {
                if (p.level === "write") {
                    countWrite++
                }
            })
            if(countWrite > 0){
                access = true
            }
        }
        return access
    }

    const openExternalAppinNewTab = (url:string) =>{
        setOpenAppsCard(false)
        try {
            window.open(url)
        } catch (error) {
            console.debug(error)
        }
    }


    return (
        <div className="SaludProxApps__Card">
            {/* Header */}
            <img
                className="SaludProxAppsLogo"
                src={SaludProxAppsLogo}
                alt="SaludProxApps Logo"
            />

            {/* Apps */}
            <div className="SaludProxApps__CardsContainer">
                <div className="SaludProxApps__CardContainer"
                    onClick={() => openExternalAppinNewTab(`${environment.protocol}${getSubdomainByLocation("saludProx")}.${environment.saludDomain}/login?platform=drprox`)}
                >
                    <img
                        className="SaludProxLogo"
                        src={SaludProxLogo}
                        alt="SaludProx Logo"
                    />
                </div>
                <div className="SaludProxApps__CardContainer-Active">
                    <img
                        className="DoctorProxLogo"
                        src={DoctorProxLogo}
                        alt="DoctorProx Logo"
                    />   
                </div> 
                { (getSubdomainByLocation("reports") === "" || validAccessRoles() === false) ? null 
                :
                <div className="SaludProxApps__CardContainer"
                    onClick={() => openExternalAppinNewTab(`${environment.protocol}${getSubdomainByLocation("reports")}.${environment.hubioIp}/login?platform=drprox&organizationId=${organizationId}`)}
                >
                    <img
                        className="ReportesLogo"
                        src={ReportesLogo}
                        alt="Reportes Logo"
                    />
                </div>
                }
                { (getSubdomainByLocation("operational") !== "" && getRole("OS"))  ? 
                                <div className="SaludProxApps__CardContainer" 
                                onClick={() => openExternalAppinNewTab(`${environment.protocol}${getSubdomainByLocation("operational")}.${environment.hubioIp}/login?platform=drprox`)}
                            >
                                <img
                                    className="SistemaOperacionalLogo"
                                    src={SistemaOperacionalLogo}
                                    alt="SistemaOperacional Logo"
                                />
                            </div>  
                : <> </>
                }
            </div>
        </div>
    )
}

export default SaludProxApps
